import ViewContentRelated from '../implementations/View/ContentRelated';
import ViewDocs from '../implementations/View/Docs';
import ViewFaq from '../implementations/View/Faq';
import ViewNestedTaxonomies from '../implementations/View/NestedTaxonomies';
import ViewParentTaxonomies from '../implementations/View/ParentTaxonomies';
import ViewThemesForTargetAudiences from '../implementations/View/ThemesForTargetAudiences';

const mappers = {
  views_block__docs_docs_by_target_audience: ViewDocs,
  views_block__docs_docs_by_theme: ViewDocs,
  views_block__article_by_projects: ViewContentRelated,
  views_block__article_by_target_audience: ViewContentRelated,
  views_block__article_by_theme: ViewContentRelated,
  views_block__article_highlights_large: ViewContentRelated,
  views_block__events_by_target_audience: ViewContentRelated,
  views_block__events_by_target_audience_large: ViewContentRelated,
  views_block__events_by_theme: ViewContentRelated,
  views_block__faq_default: ViewFaq,
  views_block__taxonomy_nested: ViewNestedTaxonomies,
  views_block__taxonomy_parents: ViewParentTaxonomies,
  views_block__taxonomy_themes_for_target_audiences: ViewThemesForTargetAudiences,
};

export default mappers;
